<script>

import { Overlay } from '../../'

export default {
    name: 'VisualCandles',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'Mano', version: '1.0.0',
                desc: 'VisualCandles',
                preset: {
                    name: 'VisualCandles',
                    side: 'onchart',
                    group: 'Visual Trading',
                    settings: {
                        lineWidth: 2
                    }
                }
            }
        },
        use_for() { return ['VisualCandles'] },
        calc() {
            return {
                props: {
                },
                conf: { renderer: 'VTCandles' }
            }
        }
    }
}
</script>
